module.exports = __webpack_public_path__ + "img/wheel_buyfeature_super_mg.48d635d8.png";